import { Link, useLocation, useNavigate } from "react-router-dom";

// Lote 131 (Robson, 27/10/2026): "Voltar" volta para a tela e aba de onde a pessoa veio. Se ela chegou
// direto (link, notificação, recarregou a página), cai no destino padrão `to`.
export default function VoltarLink({ to, children, className = "", ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();
  const temHistorico = location.key && location.key !== "default";
  return (
    <Link
      to={to}
      className={className}
      onClick={(e) => {
        if (!temHistorico) return;           // sem histórico no app: segue o link normal
        e.preventDefault();
        navigate(-1);
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}
